import { createActionWithPayload } from "store/helpers";
import { ActionTypes } from "./types";
import { IChatGroup, IChatOptions } from "@deltasge/marauders-map";

export const setUnreads = createActionWithPayload<IChatGroup[]>(
  ActionTypes.SET
);

export const setChatOptions = createActionWithPayload<IChatOptions>(
  ActionTypes.SETOPTIONS
);
